// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"beb90bba","156":"5b6ebfbb","463":"f4adeab2","465":"ac05f9ba","484":"59700b74","639":"945b71c7","719":"f95b2722","787":"5848a89e","802":"79d3eaf1","892":"b4208a7e"}[chunkId] + ".chunk.js";
};